import { convertToCamelCaseFromUnderScore } from '../../../../bd-tool/utils';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { modalConstants } from './constants';
import DeleteIcon from '@mui/icons-material/Delete';

const TableConfig = (departmentList) => {
  const headers = [
    { label: 'Name', id: 'name' },
    {
      label: 'Approval Type',
      id: 'approvalType',
      valueConversionLogic: (val) => convertToCamelCaseFromUnderScore(val),
    },
    {
      label: 'Workflow Type',
      id: 'workFlowType',
      valueConversionLogic: (val) => convertToCamelCaseFromUnderScore(val),
    },
    {
      label: 'Department',
      id: 'department',
      valueConversionLogic: (val) => {
        return departmentList.find(
          (dept) => parseInt(dept?.value) === parseInt(val)
        )?.label;
      },
    },
    { label: 'Location Type', id: 'locationType' },
    { label: 'Max Amount', id: 'maxAmount' },
    {
      label: 'Actions',
      id: 'actions',
      render: (data, onclick) => {
        return (
          <>
            <IconButton
              onClick={() => {
                onclick(data, modalConstants.update);
              }}
              sx={{ p: 0 }}
            >
              <EditIcon id="edit" />
            </IconButton>
            <IconButton
              onClick={() => {
                onclick(data, modalConstants.delete);
              }}
              sx={{ p: 0 }}
            >
              <DeleteIcon id="edit" />
            </IconButton>
          </>
        );
      },
    },
  ];

  return headers;
};

export default TableConfig;
